import { ModalHeader, ModalBody, ModalSubHeaderStyled, ButtonAppearance, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ModalSubHeader = styled(ModalSubHeaderStyled)`
  ${({ theme }) => css`
    padding: ${theme.spacings[550]} ${theme.spacings[500]};
  `}
`;

export const ModalHeaderStyled = styled(ModalHeader)`
  ${({ theme }) => css`
    min-width: ${theme.breakpoints.mobile};
    background: ${theme.colors.bechtel.blue[800]};
  `}

  h1 {
    color: ${({ theme }) => theme.colors.white};
    font-weight: ${({ theme }) => theme.fontWeights[600]};
  }
  button {
    background: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
      background-color: ${({ theme }) => theme.colors.bechtel.blue[800]};
    }
  }
`;

export const ModalBodyStyled = styled(ModalBody)`
  flex-direction: column;
`;

export const ModalFooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-left: ${theme.spacings['600']};
    padding-right: ${theme.spacings['600']};
  `}
`;
